import { render } from "./InscriptionThead.vue?vue&type=template&id=05c6250d&scoped=true"
import script from "./InscriptionThead.vue?vue&type=script&lang=js"
export * from "./InscriptionThead.vue?vue&type=script&lang=js"

import "./InscriptionThead.vue?vue&type=style&index=0&id=05c6250d&scoped=true&lang=css"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c6250d"]])

export default __exports__